import { ContributorPaymentModel } from './contributor.payment.model';

export class PagedContributorPaymentDetail {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: Array<ContributorPaymentModel>;

    constructor() {
        this.items = new Array<ContributorPaymentModel>();
    }
}
